@if (title) {
  <h3 class="card-option-list__title">{{ title }}</h3>
}
@if (!!options && options.length > 0) {
  <ul class="card-option-list">
    @for (option of options || []; track option.type) {
      <li class="card-option-list__item">
        <osp-card-option
          [icon]="option.icon"
          [label]="option.label"
          [selected]="selectedOption() === option.type"
          [selectable]="selectable"
          [description]="option.description"
          (click)="handleCardClicked(option.type)"
        />
      </li>
    }
  </ul>
}
